import React, { useState, useEffect, useImperativeHandle } from 'react';
import * as Ui from './styles';

function InputTextReferenciable({
  placeholder = 'Digite aqui...',
  required = false,
  disabled = false,
  hasError = false,
  value,
  background,
  onChange,
  onExit,
  defaultValue,
  // define o numero maximo de caracteres
  maxLength,
}, ref) {
  // more performance
  let timeout = -1;
  // states
  const [wasEdited, setWasEdited] = useState(false);
  const [textValue, setTextValue] = useState('');

  useEffect(() => {
    if (textValue !== value && value && !textValue && !wasEdited) {
      setTextValue(value);
    }
  }, [textValue, value, wasEdited]);

  useEffect(() => {
    setTextValue(defaultValue);
  }, [defaultValue]);

  useImperativeHandle(ref, () => ({
    clear: () => {
      setTextValue('');
    },
    // Externalizando método para setar o valor do texto
    setText: (text) => {
      setTextValue(text);
    },
  }), []);

  // handle text change
  function handleChangeText(e) {
    setWasEdited(true);
    setTextValue(e.target.value);
    // delay for fire event
    const eventValue = e.target.value;
    clearTimeout(timeout);
    timeout = setTimeout(() => {
      if (onChange) onChange(eventValue);
    }, 1);
  }

  // handle text change (on final)
  function handleExitText() {
    if (onExit) onExit(textValue);
  }

  return (
    <Ui.InputContainer 
      background={background}
      hasError={hasError}
    >
      <input
        type="text"
        className="inputText"
        placeholder={placeholder}
        required={required ? 'required' : ''}
        disabled={disabled ? 'disabled' : ''}
        value={textValue}
        onChange={(e) => handleChangeText(e)}
        onBlur={() => handleExitText()}
        maxLength={maxLength || null}
      />
    </Ui.InputContainer>
  );
}

const InputText = React.forwardRef(InputTextReferenciable);
export { InputText };
